import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.function.name";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
import PropTypes from 'prop-types';
import hoistStatics from 'hoist-non-react-statics';
import * as _ from 'lodash';
import normalizeStyle from "./StyleNormalizer/normalizeStyle";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import Theme, { ThemeShape } from "./Theme";
import { resolveComponentStyle } from "./resolveComponentStyle";
var themeCache = {};
export function clearThemeCache() {
  themeCache = {};
}

function throwConnectStyleError(errorMessage, componentDisplayName) {
  throw Error(errorMessage + " - when connecting " + componentDisplayName + " component to style.");
}

function getTheme(context) {
  return context.theme || Theme.getDefaultTheme();
}

function isStyleVariant(propertyName) {
  return /^\./.test(propertyName);
}

function isChildStyle(propertyName) {
  return /(^[^\.].*\.)|^\*$/.test(propertyName);
}

function getConcreteStyle(style) {
  return _.pickBy(style, function (value, key) {
    return !isStyleVariant(key) && !isChildStyle(key);
  });
}

export default (function (componentStyleName) {
  var componentStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mapPropsToStyleNames = arguments.length > 2 ? arguments[2] : undefined;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  function getComponentDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }

  return function wrapWithStyledComponent(WrappedComponent) {
    var componentDisplayName = getComponentDisplayName(WrappedComponent);

    if (!_.isPlainObject(componentStyle)) {
      throwConnectStyleError("Component style must be plain object", componentDisplayName);
    }

    if (!_.isString(componentStyleName)) {
      throwConnectStyleError("Component Style Name must be string", componentDisplayName);
    }

    var StyledComponent = function (_React$Component) {
      _inherits(StyledComponent, _React$Component);

      function StyledComponent(props, context) {
        var _this;

        _classCallCheck(this, StyledComponent);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(StyledComponent).call(this, props, context));

        var styleNames = _this.getStyleNames(props);

        var style = props.style;

        var finalStyle = _this.getFinalStyle(props, context, style, styleNames);

        _this.setWrappedInstance = _this.setWrappedInstance.bind(_assertThisInitialized(_this));
        _this.resolveConnectedComponentStyle = _this.resolveConnectedComponentStyle.bind(_assertThisInitialized(_this));
        _this.state = {
          style: finalStyle,
          addedProps: _this.resolveAddedProps(),
          styleNames: styleNames
        };
        return _this;
      }

      _createClass(StyledComponent, [{
        key: "getFinalStyle",
        value: function getFinalStyle(props, context, style, styleNames) {
          var resolvedStyle = {};

          if (context.parentPath) {
            resolvedStyle = this.getOrSetStylesInCache(context, props, styleNames, [].concat(_toConsumableArray(context.parentPath), [componentStyleName], _toConsumableArray(styleNames)));
          } else {
            resolvedStyle = this.resolveStyle(context, props, styleNames);
            themeCache[componentStyleName] = resolvedStyle;
          }

          var concreteStyle = getConcreteStyle(_.merge({}, resolvedStyle));

          if (_.isArray(style)) {
            return [concreteStyle].concat(_toConsumableArray(style));
          }

          if (typeof style == "number" || typeof style == "object") {
            return [concreteStyle, style];
          }

          return concreteStyle;
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames(props) {
          var styleNamesArr = _.map(props, function (value, key) {
            if (typeof value !== "object" && value === true) {
              return "." + key;
            } else {
              return false;
            }
          });

          _.remove(styleNamesArr, function (value, index) {
            return value === false;
          });

          return styleNamesArr;
        }
      }, {
        key: "getParentPath",
        value: function getParentPath() {
          if (!this.context.parentPath) {
            return [componentStyleName];
          } else {
            return [].concat(_toConsumableArray(this.context.parentPath), [componentStyleName], _toConsumableArray(this.getStyleNames(this.props)));
          }
        }
      }, {
        key: "getChildContext",
        value: function getChildContext() {
          return {
            parentPath: this.getParentPath()
          };
        }
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
          var styleNames = this.getStyleNames(nextProps);
          var style = nextProps.style;

          if (this.shouldRebuildStyle(nextProps, nextContext, styleNames)) {
            var finalStyle = this.getFinalStyle(nextProps, nextContext, style, styleNames);
            this.setState({
              style: finalStyle,
              styleNames: styleNames
            });
          }
        }
      }, {
        key: "setNativeProps",
        value: function setNativeProps(nativeProps) {
          if (this.wrappedInstance.setNativeProps) {
            this.wrappedInstance.setNativeProps(nativeProps);
          }
        }
      }, {
        key: "setWrappedInstance",
        value: function setWrappedInstance(component) {
          if (component && component._root) {
            this._root = component._root;
          } else {
            this._root = component;
          }

          this.wrappedInstance = this._root;
        }
      }, {
        key: "hasStyleNameChanged",
        value: function hasStyleNameChanged(nextProps, styleNames) {
          return mapPropsToStyleNames && this.props !== nextProps && !_.isEqual(this.state.styleNames, styleNames);
        }
      }, {
        key: "shouldRebuildStyle",
        value: function shouldRebuildStyle(nextProps, nextContext, styleNames) {
          return nextProps.style !== this.props.style || nextProps.styleName !== this.props.styleName || nextContext.theme !== this.context.theme || !_.isEqual(nextContext.parentPath, this.context.parentPath) || this.hasStyleNameChanged(nextProps, styleNames);
        }
      }, {
        key: "resolveStyleNames",
        value: function resolveStyleNames(props) {
          var styleName = props.styleName;
          var styleNames = styleName ? styleName.split(/\s/g) : [];

          if (!mapPropsToStyleNames) {
            return styleNames;
          }

          return _.uniq(mapPropsToStyleNames(styleNames, props));
        }
      }, {
        key: "resolveAddedProps",
        value: function resolveAddedProps() {
          var addedProps = {};

          if (options.withRef) {
            addedProps.ref = "wrappedInstance";
          }

          return addedProps;
        }
      }, {
        key: "getOrSetStylesInCache",
        value: function getOrSetStylesInCache(context, props, styleNames, path) {
          if (themeCache && themeCache[path.join(">")]) {
            return themeCache[path.join(">")];
          } else {
            var resolvedStyle = this.resolveStyle(context, props, styleNames);

            if (Object.keys(themeCache).length < 10000) {
              themeCache[path.join(">")] = resolvedStyle;
            }

            return resolvedStyle;
          }
        }
      }, {
        key: "resolveStyle",
        value: function resolveStyle(context, props, styleNames) {
          var parentStyle = {};
          var theme = getTheme(context);
          var themeStyle = theme.createComponentStyle(componentStyleName, componentStyle);

          if (context.parentPath) {
            parentStyle = themeCache[context.parentPath.join(">")];
          } else {
            parentStyle = resolveComponentStyle(componentStyleName, styleNames, themeStyle, parentStyle);
          }

          return resolveComponentStyle(componentStyleName, styleNames, themeStyle, parentStyle);
        }
      }, {
        key: "resolveConnectedComponentStyle",
        value: function resolveConnectedComponentStyle(props) {
          var styleNames = this.resolveStyleNames(props);
          return this.resolveStyle(this.context, props, styleNames).componentStyle;
        }
      }, {
        key: "render",
        value: function render() {
          var _this$state = this.state,
              addedProps = _this$state.addedProps,
              style = _this$state.style;
          return React.createElement(WrappedComponent, _extends({}, this.props, addedProps, {
            style: style,
            ref: this.setWrappedInstance
          }));
        }
      }]);

      return StyledComponent;
    }(React.Component);

    StyledComponent.contextTypes = {
      theme: ThemeShape,
      parentPath: PropTypes.array
    };
    StyledComponent.childContextTypes = {
      parentPath: PropTypes.array
    };
    StyledComponent.propTypes = {
      style: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
      styleName: PropTypes.string,
      virtual: PropTypes.bool
    };
    StyledComponent.defaultProps = {
      virtual: options.virtual
    };
    StyledComponent.displayName = "Styled(" + componentDisplayName + ")";
    StyledComponent.WrappedComponent = WrappedComponent;
    return hoistStatics(StyledComponent, WrappedComponent);
  };
});